import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=f550ec18&scoped=true&"
import script from "./Manufacturers.vue?vue&type=script&lang=ts&"
export * from "./Manufacturers.vue?vue&type=script&lang=ts&"
import style0 from "./Manufacturers.vue?vue&type=style&index=0&id=f550ec18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f550ec18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/travis/build/Coder-256/database-phoenix/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
